module.exports = __webpack_public_path__ + "static/media/juizeEco.9fc68437.png";